<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        07.15
        <br />2017
      </span>
      <span class="tiel">最美菜公益基金滞销菜帮扶计划启动 滞销菜帮扶联盟助力农产品流通</span>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a5.jpg" width="640" />
      </p>
      <div
        class="tet-js"
      >今年以来蔬菜滞销卖难的消息不断传来，为帮扶传统老农摆脱滞销困境，7月15日，中国红十字基金会最美菜公益基金联合共青团美菜网委员会，共同发起滞销菜帮扶计划的公益项目。当天，来自高校、机构、超市、媒体、互联网农业企业等9个单位，成立滞销菜帮扶联盟，将合力助销滞销农产品。与此同时，一部反映滞销现状及原因的调查纪录片《苍天厚土》正式发布，呼吁各方共同帮扶困境中滞销菜农。</div>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>滞销菜帮扶计划旨在缓解滞销现状
      </div>
      <div class="tet-js">
        据滞销菜帮扶联盟成员，中国农业大学中国农户经济研究中心的数据库研究显示，2001-2012年，12年间全国发生滞销事件共计622件。2013-2017年6月，4年半的时间，发生滞销的事件为1612起。滞销事件发生的频率成倍增加。
        <br />
        <br />今年以来蔬菜滞销严重到什么程度呢？根据该数据库的统计，今年上半年，蔬菜滞销共发生175起，几乎超过了以往年份全年的滞销菜事件数量。
        <br />
        <br />在这样的背景下，中国红十字基金会最美菜公益基金联合共青团美菜网委员会共同发起滞销菜帮扶计划的公益项目，旨在帮扶传统老农，爱心助销滞销农产品。
        <br />
        <br />该项目以美菜网的主营业务为依托，联合行业内各大商超和批发市场，搭建助农惠民的信息平台，为滞销农户拓宽销路，寻找销售希望，让农产品通过互联网真正走出乡村。
        <br />
        <br />从长远来看，美菜网商城大数据中心将对百万家餐饮商户下单规律和市场走势进行分析，为菜农提供次年种植指导意见，尽最大努力避免农副产品种植养殖“扎堆”、“滞销”的困境。
      </div>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>滞销菜帮扶联盟面向社会开放
      </div>
      <div class="tet-js">
        当天的启动仪式上，中国红十字基金会、中国农业大学中国农户经济研究中心、美菜网、新发地、华润万家、超市发、健力源、企鹅媒体平台、一直播共9家单位作为首批滞销菜帮扶联盟成员，共同发起滞销菜帮扶计划。
        <br />
        <br />据了解，首批联盟成员包括滞销菜救助原则的制定方、滞销菜信息采集的收集方、相关涉农企业作为渠道方、相关研究院所作为战略支持方。四方将合力完成实际采购行为，最终帮扶滞销菜农，形成一条闭环链条。
        <br />
        <br />最美菜公益基金委员会主任、美菜网副总裁李洪洋介绍，滞销菜帮扶联盟也将面向社会开放，除了到场的发起单位以外，只要是关注滞销领域、想为传统老农农产品流通助力的个人和团队均可以参与进来。
        <br />
        <br />值得注意的是，滞销菜品并非次品，而是仅仅因为销售渠道不畅而无法抵达城市端餐桌的农产品，同时联盟成员约定采购的滞销菜品首先要符合各自的采购条件。
        <br />
        <br />广大的市民朋友，也可以身体力行加入到滞销帮扶计划中。市民可以在联盟单位超市、市场中，以公益价格购买滞销菜品。广大的餐厅商户，也可以通过美菜网以公益价格购买滞销菜菜品，一些企业的员工也可通过团餐企业健力源品尝到滞销菜品，进而共同助力传统农产品的流通。
      </div>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>10家餐厅获滞销菜帮扶最美餐厅殊荣
      </div>
      <div class="tet-js">
        事实上，滞销菜帮扶计划在安徽亳州、山东潍坊已经成功实践两次。5月，亳州近万亩土豆滞销，美菜网爱心助销，10天内消化滞销土豆近100万斤；6月，农业部发起山东滞销圆葱对接活动，美菜网签订意向采购200万斤，并次日就赴滞销地方开始采购行动。
        <br />
        <br />其中，在山东滞销圆葱的爱心帮扶行动中，首日上线美菜商城的销量比往日增长三倍。活动期间，购买频次最高且采购量最多的十家餐厅，获得由中国红十字基金会和最美菜公益基金共同颁发的“滞销菜帮扶计划最美餐厅”的荣誉称号。
        <br />
        <br />
        <p align="center">
          <img src="@/assets/images/new-img/a5_1.jpg" width="640" />
          <br />最美餐厅获奖合影
        </p>
        <br />作为滞销菜帮扶计划的发起方，美菜网CEO刘传军表示，美菜网以千万家餐厅作为目标客户，其对于农产品的采购需求是量大且稳定的。当餐厅参与到爱心助销环节中，就可以大量且持续的消化滞销菜品，反作用于源头传统农业。同时，美菜模式能架起源头和餐厅的桥梁，打破传统的流通模式，让农产品可以一站式达到餐厅。此外，美菜还将致力于通过大数据分析，提供种养殖建议，最大努力避免滞销的困境。
      </div>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>首部滞销菜调查纪录片《苍天厚土》发布
      </div>
      <div class="tet-js">
        在启动仪式上，最美菜公益基金发布了调查纪录片《苍天厚土》，根据调查结论，2001年至2017年，我国农产品发生的滞销事件涉及31个省（市、自治区）、314个地级城市，涉及292个农产品品种，而蔬菜和水果的比例占比达86%。其中，蔬菜是最容易发生滞销的农产品，占比超过45%。值得注意的是，17年间，我国出现的农产品滞销主要是供过于求带来的价格下跌。
        <br />
        <br />古语道，菜贱伤农。滞销事件对于农民的影响是显而易见的，但滞销影响的严重程度，可能远远超过想象。《苍天厚土》的纪录片中，采访到一名农妇，她的丈夫今年5月19日，因菜品滞销而喝农药结束了自己的生命。农妇在纪录片中，泣不成声，还表示接下来不愿再种地了，要出去打工养活一家人生计。
        <br />
        <br />此外，最美菜公益基金还用动画的形式还原了蔬菜传统供应链，以解释“地头贱，摊头不贱”的怪象。
        <br />
        <br />《苍天厚土》的调查纪录片还试图寻找解决滞销问题的途径，调查给出的建议是：其一，提高小产区种植技术，多客商帮扶订单适当转向小产区；其二，农产品主产区加大品牌建设，进行差异化营销；其三，要加大蔬果初级加工，促进冷链储藏和冷链物流的建设；同时，还要利用互联网＋大数据实现信息有效匹配。
        <br />
        <br />《苍天厚土》调查纪录片的发布，不仅是要引起社会对滞销事件的重视，更是要聚集各方力量来降低滞销事件的发生概率，并架起滞销菜链接市场的绿色通道。同时，也讲述那些项目背后默默奉献的个人和团体的故事，优秀个人和组织还将获得由中国红十字基金会授予“优秀志愿者”、“优秀志愿团体”的荣誉。
        <br />
        <br />此次发布仪式有相关单位领导、媒体记者、协会领导、行业代表及美菜代表等一千多人出席，共同见证和参与此次发布活动。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
